import { Component, OnInit } from '@angular/core';

import { BasicNotificationElementComponent } from '../basic-notification-element/basic-notification-element.component';

@Component({
    selector: 'ridango-basic-success-notification',
    templateUrl: './basic-success-notification.component.html',
    styleUrls: ['./basic-success-notification.component.scss'],
})
export class BasicSuccessNotificationComponent extends BasicNotificationElementComponent implements OnInit {
    constructor() {
        super();
    }

    ngOnInit() {
        this.title = this.notification.title ? this.notification.title : 'success';
        this.message = this.notification.message;
    }
}
